const { app, Order, UI } = Mobi2Go;
const is_mobile_ui = app.isMobileUI();

export default (action, category, product, all_suggestions_count) => {
    Order.log('product suggestion clicked', {
        product_suggestion: {
            action,
            category,
            product,
            all_suggestions_count,
        },
        items_section: true,
    });

    switch (action) {
        case 'show_product':
        case 'add_product': {
            const menu_products = Mobi2Go.Menu.getProducts();
            const menu_product = menu_products.getById(product.menu_product.id);

            if (menu_product) {
                const order_product = menu_product.createOrderProductInstance();

                // If there are multiple suggestions, only add one item
                if (all_suggestions_count === 1) {
                    order_product.setQuantity(product.quantity);
                }

                if (product.modifiers && product.modifiers.length) {
                    order_product.setModifiers(product.modifiers);
                }

                // Quick add
                const ignore_size_requirement = product.modifiers.length > 0;
                if (
                    order_product.shouldQuickAddToOrder(ignore_size_requirement)
                ) {
                    Order.addProduct(order_product);
                } else if (is_mobile_ui) {
                    UI.page.disableAnimation();
                    UI.trigger('editProduct', order_product, () => {
                        UI.trigger('showOrderEditor');
                    });
                    UI.page.restoreAnimation();
                } else {
                    UI.trigger('editProduct', order_product);
                }
            }

            break;
        }

        case 'show_category': {
            UI.trigger('showCategory', category.menu_category.id);
            UI.trigger('scrollToCategory', category.menu_category.id, true);

            break;
        }
        default:
            break;
    }
};
